export default __webpack_public_path__ + "1bd112b7a1dbe02aa34dfe559626bdb3.png";